'use client';

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import ImageContainer from '@/components/ImageContainer';
import NextImage from '@/components/NextImage';

import { BlocksAttributes, InnerBlocks } from '@/models/Blocks';

export default function GalleryBlock(
  props: BlocksAttributes & {
    innerBlocks?: InnerBlocks[];
  },
) {
  const { innerBlocks } = props;

  if (!innerBlocks?.length) return <></>;

  return (
    <div className='overflow-hidden'>
      <Swiper
        className='mb-12 rounded-2xl'
        modules={[Navigation, Pagination]}
        pagination={{
          type: 'fraction',
          renderFraction: (currentClass: string, totalClass: string) =>
            '<span class="' +
            currentClass +
            '"></span>' +
            ' of ' +
            '<span class="' +
            totalClass +
            '"></span>',
        }}
        navigation
        autoHeight={true}
      >
        {innerBlocks?.map((block: InnerBlocks, index: number) => (
          <SwiperSlide key={index}>
            <ImageContainer hasCaption={false}>
              <NextImage
                src={block?.attributes?.url || ''}
                alt={block?.attributes?.alt || ''}
                caption={block?.attributes?.caption || undefined}
                className='w-full'
                classNames={{ image: 'w-full h-full object-cover' }}
                captionInside={true}
                width='820'
                height='480'
              />
            </ImageContainer>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
